<template>
  <div class="living-area">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/lebensbereiche">Lebensbereiche</router-link>
      <router-link :to="`/lebensbereiche/${livingArea.id}`">{{livingArea.name}}</router-link>
    </Breadcrumb>
    <div class="wrapper margin-bottom--60 margin-top--40">
      <div class="living-area__description row middle-xs margin-bottom--50">
        <div class="left col-xs-12 col-md-9">
          <div class="headline-link--icon">
            <Icon :icon="livingArea.icon" color="detailed" class="hide-mobile"/>
            <Headline subline="Lebensbereich" :headline="livingArea.name" />
          </div>
          <p>{{ livingArea.description }}</p>
          <p>Für diesen Lebensbereich stehen Ihnen <span>{{ livingArea.services.length }} Dienstleistungen</span> zur Verfügung.</p>
        </div>
        <router-link :to="`/lebensbereiche/${relatedArea.id}`" class="right col-xs-3 hide-mobile">
          <Card padding="20px">
            <h3>Verwandter Lebensbereich:</h3>
            <div>
              <Icon :icon="relatedArea.icon" color="detailed" />
              <p>{{ relatedArea.name }}</p>
            </div>
          </Card>
        </router-link>
      </div>
      <SearchFilter :action="filterList" v-model="searchTerm" placeholder="Nach zugeordneten Dienstleistungen suchen..."></SearchFilter>
      <p v-if="allServices.length < 1" class="no-results">
        <span>Keine Ergebnisse</span>
        Leider konnten keine passenden Dienstleistungen in diesem Lebensbereich gefunden werden. 
        <br>Eventuell werden Sie bei der gesamten <router-link to="/services">Dienstleistungs-Übersicht</router-link> fündig.
      </p>
      <paginate v-else
            ref="paginator"
            name="allServices"
            :list="allServices"
            :per="12"
            class="margin-top--40"
          >
        <transition-group name="list" class="row">
          <div v-for="service in paginated('allServices')" :key="service.id" class="list-item col-xs-12 col-sm-6 col-md-3">
            <ServiceCard :service="service"/>
          </div>
        </transition-group>
      </paginate>
      <div v-if="allServices.length > 0" class="paginate-bottom margin-top--30">
        <span v-if="$refs.paginator">
        {{$refs.paginator.pageItemsCount}} Ergebnisse
        </span>
        <paginate-links v-if="allServices.length > 12" for="allServices" :limit="3" :step-links="{ next: '>', prev: '<' }"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import SearchFilter from '../../components/SearchFilter/SearchFilter';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import Card from '../../components/Card/Card';

export default {
  name: 'LivingArea',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    SearchFilter,
    ServiceCard,
    Card,
  },
  data() {
    return {
      msg: 'Behördengänge einfach Online erledigen',
      searchTerm: '',
      allServices: null,
      livingArea: null,
      relatedArea: null,
      paginate: [ 'allServices' ],
    };
  },
  computed: {
    ...mapGetters({
      getServicesByIds: 'services/getServicesByIds',
      getLivingAreaById: 'livingAreas/getLivingAreaById',
    }),
  },
  watch: {
    '$route.params.id': function (id) {
      this.livingArea = this.getLivingAreaById(id);
      this.relatedArea = this.getLivingAreaById(this.livingArea.relatedArea);
      this.allServices = this.getServicesByIds(this.livingArea.services);
    }
  },
  methods: {
    filterList() {
      this.allServices = this.getServicesByIds(this.livingArea.services)
      this.allServices = this.allServices.filter(service => service.title.toLowerCase().includes(this.searchTerm.toLowerCase()));
    },
  },
  created() {
    this.livingArea = this.getLivingAreaById(this.$route.params.id);
    this.relatedArea = this.getLivingAreaById(this.livingArea.relatedArea);
    this.allServices = this.getServicesByIds(this.livingArea.services);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./LivingArea.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/LivingArea/LivingArea.vue